import React from "react";

const LogoMark = ({
  width = 320,
  height = 120,
  text,
  textColor = "#292826",
  fontFamily = "'TitilliumWeb-SemiBold', sans-serif",
  fontSize = 72,
  orange = "#F57F20",
  blue = "#2B7CBA",
  red = "#EC4D37",
  yellow = "#F9D342",
}) => (
  <svg
    width={width}
    height={height}
    viewBox={text ? "80 240 1360 320" : "80 240 340 320"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Orange diamond */}
    <path
      d="M280.71,358.72l49.7,49.7c4.57,4.57,11.99,4.57,16.57,0l49.7-49.7
      c4.57-4.57,4.57-11.99,0-16.57l-49.7-49.7
      c-4.57-4.57-11.99-4.57-16.57,0l-49.7,49.7
      C276.13,346.73,276.13,354.14,280.71,358.72z
      M338.69,317.31l33.13,33.13l-33.13,33.13
      l-33.13-33.13L338.69,317.31z"
      fill={orange}
    />

    {/* Blue small diamond */}
    <path
      d="M247.27,274.03l-20.92,20.92
      c-3.37,3.37-3.37,8.84,0,12.21l20.92,20.92
      c3.37,3.37,8.84,3.37,12.21,0l20.92-20.92
      c3.37-3.37,3.37-8.84,0-12.21l-20.92-20.92
      C256.11,270.66,250.64,270.66,247.27,274.03z
      M253.38,292.35l8.7,8.7l-8.7,8.7l-8.7-8.7
      L253.38,292.35z"
      fill={blue}
    />

    {/* Red diamond */}
    <path
      d="M160.2,292.46l-49.7,49.7
      c-4.57,4.57-4.57,11.99,0,16.57l49.7,49.7
      c4.57,4.57,11.99,4.57,16.57,0l49.7-49.7
      c4.57-4.57,4.57-11.99,0-16.57l-49.7-49.7
      C172.19,287.88,164.77,287.88,160.2,292.46z
      M168.48,317.31l33.13,33.13l-33.13,33.13
      l-33.13-33.13L168.48,317.31z"
      fill={red}
    />

    {/* Yellow diamond */}
    <path
      d="M195.4,443.37l49.7,49.7
      c4.57,4.57,11.99,4.57,16.57,0l49.7-49.7
      c4.57-4.57,4.57-11.99,0-16.57l-49.7-49.7
      c-4.57-4.57-11.99-4.57-16.57,0l-49.7,49.7
      C190.82,431.38,190.82,438.8,195.4,443.37z
      M253.38,401.96l33.13,33.13l-33.13,33.13
      l-33.13-33.13L253.38,401.96z"
      fill={yellow}
    />

    {/* Optional Text */}
    {text && (
      <text
        x="430"
        y="420"
        fill={textColor}
        fontFamily={fontFamily}
        fontSize={fontSize}
        fontWeight="600"
        letterSpacing="1"
      >
        {text}
      </text>
    )}
  </svg>
);

export default LogoMark;
